module.exports = __webpack_public_path__ + "static/media/content-blur-bg.28519694.jpg";